/**
 * @flow
 * @relayHash 8e99bea3f0dfa3bf6d92484b115fd29e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MostDesiredPlants_viewer$ref = any;
type PeopleWhoPlant_viewer$ref = any;
type PopularPlants_viewer$ref = any;
type RecentPosts_viewer$ref = any;
export type HomeQueryVariables = {||};
export type HomeQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: PopularPlants_viewer$ref & MostDesiredPlants_viewer$ref & PeopleWhoPlant_viewer$ref & RecentPosts_viewer$ref
  |}
|};
export type HomeQuery = {|
  variables: HomeQueryVariables,
  response: HomeQueryResponse,
|};
*/


/*
query HomeQuery {
  viewer {
    ...PopularPlants_viewer_VbLdN
    ...MostDesiredPlants_viewer_VbLdN
    ...PeopleWhoPlant_viewer_VbLdN
    ...RecentPosts_viewer_41grAF
    id
  }
}

fragment PopularPlants_viewer_VbLdN on Query {
  popularPlants: allLifeNode(first: 5, orderBy: "-collection_count") {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        idInt
        title
        slug
        ...PlantItem_lifeNode
        images(first: 1) {
          edges {
            node {
              id
              bigImage: image(width: 440, height: 520) {
                url
              }
            }
          }
        }
        __typename
      }
      cursor
    }
  }
}

fragment MostDesiredPlants_viewer_VbLdN on Query {
  mostDesiredPlants: allLifeNode(first: 5, orderBy: "-wish_count") {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        idInt
        title
        slug
        ...PlantItem_lifeNode
        images(first: 1) {
          edges {
            node {
              id
              bigImage: image(width: 440, height: 520) {
                url
              }
            }
          }
        }
        __typename
      }
      cursor
    }
  }
}

fragment PeopleWhoPlant_viewer_VbLdN on Query {
  allUsers(first: 5, orderBy: "-collection_count") {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        firstName
        lastName
        dateJoined
        username
        reputation
        avatar(width: 40, height: 40) {
          url
        }
        collectionList {
          totalCount
        }
        __typename
      }
      cursor
    }
  }
}

fragment RecentPosts_viewer_41grAF on Query {
  recentPosts: allPosts(first: 3) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        title
        summary
        mainImage {
          id
          smallImage: image(width: 225, height: 300) {
            url
          }
        }
        url
        __typename
      }
      cursor
    }
  }
}

fragment PlantItem_lifeNode on LifeNode {
  id
  idInt
  title
  slug
  rankDisplay
  commonName {
    name
    id
  }
  images(first: 1) {
    edges {
      node {
        id
        bigImage: image(width: 440, height: 520) {
          url
        }
      }
    }
  }
  commonNames(first: 20) {
    edges {
      node {
        id
        name
        language
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "count",
    "value": 5
  }
],
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "-collection_count"
  }
],
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v11 = [
  (v3/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "LifeNodeEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "LifeNode",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "idInt",
            "args": null,
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "slug",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "rankDisplay",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "commonName",
            "storageKey": null,
            "args": null,
            "concreteType": "CommonName",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v4/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "images",
            "storageKey": "images(first:1)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "ImageConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ImageEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Image",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": "bigImage",
                        "name": "image",
                        "storageKey": "image(height:520,width:440)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 520
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 440
                          }
                        ],
                        "concreteType": "File",
                        "plural": false,
                        "selections": (v8/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "commonNames",
            "storageKey": "commonNames(first:20)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 20
              }
            ],
            "concreteType": "CommonNameConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CommonNameEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CommonName",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "language",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v9/*: any*/)
        ]
      },
      (v10/*: any*/)
    ]
  }
],
v12 = [
  "orderBy"
],
v13 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "-wish_count"
  }
],
v14 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "HomeQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PopularPlants_viewer",
            "args": (v0/*: any*/)
          },
          {
            "kind": "FragmentSpread",
            "name": "MostDesiredPlants_viewer",
            "args": (v0/*: any*/)
          },
          {
            "kind": "FragmentSpread",
            "name": "PeopleWhoPlant_viewer",
            "args": (v0/*: any*/)
          },
          {
            "kind": "FragmentSpread",
            "name": "RecentPosts_viewer",
            "args": [
              {
                "kind": "Literal",
                "name": "count",
                "value": 3
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "HomeQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "popularPlants",
            "name": "allLifeNode",
            "storageKey": "allLifeNode(first:5,orderBy:\"-collection_count\")",
            "args": (v2/*: any*/),
            "concreteType": "LifeNodeConnection",
            "plural": false,
            "selections": (v11/*: any*/)
          },
          {
            "kind": "LinkedHandle",
            "alias": "popularPlants",
            "name": "allLifeNode",
            "args": (v2/*: any*/),
            "handle": "connection",
            "key": "PopularPlants_popularPlants",
            "filters": (v12/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": "mostDesiredPlants",
            "name": "allLifeNode",
            "storageKey": "allLifeNode(first:5,orderBy:\"-wish_count\")",
            "args": (v13/*: any*/),
            "concreteType": "LifeNodeConnection",
            "plural": false,
            "selections": (v11/*: any*/)
          },
          {
            "kind": "LinkedHandle",
            "alias": "mostDesiredPlants",
            "name": "allLifeNode",
            "args": (v13/*: any*/),
            "handle": "connection",
            "key": "MostDesiredPlants_mostDesiredPlants",
            "filters": (v12/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "allUsers",
            "storageKey": "allUsers(first:5,orderBy:\"-collection_count\")",
            "args": (v2/*: any*/),
            "concreteType": "UserConnection",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "dateJoined",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "username",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "reputation",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "avatar",
                        "storageKey": "avatar(height:40,width:40)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 40
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 40
                          }
                        ],
                        "concreteType": "File",
                        "plural": false,
                        "selections": (v8/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "collectionList",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CollectionItemConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "totalCount",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      (v9/*: any*/)
                    ]
                  },
                  (v10/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "allUsers",
            "args": (v2/*: any*/),
            "handle": "connection",
            "key": "PeopleWhoPlant_allUsers",
            "filters": (v12/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": "recentPosts",
            "name": "allPosts",
            "storageKey": "allPosts(first:3)",
            "args": (v14/*: any*/),
            "concreteType": "PostConnection",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PostEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Post",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "summary",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "mainImage",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Image",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": "smallImage",
                            "name": "image",
                            "storageKey": "image(height:300,width:225)",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "height",
                                "value": 300
                              },
                              {
                                "kind": "Literal",
                                "name": "width",
                                "value": 225
                              }
                            ],
                            "concreteType": "File",
                            "plural": false,
                            "selections": (v8/*: any*/)
                          }
                        ]
                      },
                      (v7/*: any*/),
                      (v9/*: any*/)
                    ]
                  },
                  (v10/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": "recentPosts",
            "name": "allPosts",
            "args": (v14/*: any*/),
            "handle": "connection",
            "key": "RecentPosts_recentPosts",
            "filters": null
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "HomeQuery",
    "id": null,
    "text": "query HomeQuery {\n  viewer {\n    ...PopularPlants_viewer_VbLdN\n    ...MostDesiredPlants_viewer_VbLdN\n    ...PeopleWhoPlant_viewer_VbLdN\n    ...RecentPosts_viewer_41grAF\n    id\n  }\n}\n\nfragment PopularPlants_viewer_VbLdN on Query {\n  popularPlants: allLifeNode(first: 5, orderBy: \"-collection_count\") {\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        idInt\n        title\n        slug\n        ...PlantItem_lifeNode\n        images(first: 1) {\n          edges {\n            node {\n              id\n              bigImage: image(width: 440, height: 520) {\n                url\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment MostDesiredPlants_viewer_VbLdN on Query {\n  mostDesiredPlants: allLifeNode(first: 5, orderBy: \"-wish_count\") {\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        idInt\n        title\n        slug\n        ...PlantItem_lifeNode\n        images(first: 1) {\n          edges {\n            node {\n              id\n              bigImage: image(width: 440, height: 520) {\n                url\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment PeopleWhoPlant_viewer_VbLdN on Query {\n  allUsers(first: 5, orderBy: \"-collection_count\") {\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        firstName\n        lastName\n        dateJoined\n        username\n        reputation\n        avatar(width: 40, height: 40) {\n          url\n        }\n        collectionList {\n          totalCount\n        }\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment RecentPosts_viewer_41grAF on Query {\n  recentPosts: allPosts(first: 3) {\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        title\n        summary\n        mainImage {\n          id\n          smallImage: image(width: 225, height: 300) {\n            url\n          }\n        }\n        url\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment PlantItem_lifeNode on LifeNode {\n  id\n  idInt\n  title\n  slug\n  rankDisplay\n  commonName {\n    name\n    id\n  }\n  images(first: 1) {\n    edges {\n      node {\n        id\n        bigImage: image(width: 440, height: 520) {\n          url\n        }\n      }\n    }\n  }\n  commonNames(first: 20) {\n    edges {\n      node {\n        id\n        name\n        language\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5d477195a35ae40c94392e7c034347c7';
module.exports = node;
